// 検索窓の非表示問題を修正
(function() {
  'use strict';

  // 検索窓が開いているかどうかを追跡
  let searchIsOpen = false;
  let searchInput = null;

  function init() {
    // 検索関連の要素を取得
    const searchContainer = document.querySelector('.site-header__search-container');
    const searchButtons = document.querySelectorAll('.js-search-header');
    const closeButton = document.querySelector('.btn--close-search');
    
    if (!searchContainer) return;

    // 検索入力フィールドを取得
    searchInput = searchContainer.querySelector('input[type="search"], .search__input');

    // 検索ボタンのクリックイベント
    searchButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openSearch();
      });
    });

    // 閉じるボタンのクリックイベント
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeSearch();
      });
    }

    // ESCキーでの閉じる処理
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchIsOpen) {
        closeSearch();
      }
    });

    // 検索入力フィールドのフォーカス管理
    if (searchInput) {
      searchInput.addEventListener('focus', function() {
        searchIsOpen = true;
        searchContainer.classList.add('is-active');
      });

      searchInput.addEventListener('blur', function(e) {
        // 少し遅延させて、他の要素へのフォーカス移動を確認
        setTimeout(() => {
          const activeElement = document.activeElement;
          // 検索関連の要素にフォーカスがない場合のみ閉じる
          if (!searchContainer.contains(activeElement) && 
              !activeElement.closest('.site-header__search-container')) {
            closeSearch();
          }
        }, 100);
      });
    }

    // 検索コンテナ外のクリックで閉じる
    document.addEventListener('click', function(e) {
      if (searchIsOpen && !searchContainer.contains(e.target) && 
          !e.target.closest('.js-search-header')) {
        closeSearch();
      }
    });

    // 予測検索のイベントをインターセプト
    document.addEventListener('predictive-search:close', function(e) {
      // 検索入力フィールドがフォーカス中の場合は閉じない
      if (searchInput && document.activeElement === searchInput) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  }

  function openSearch() {
    const searchContainer = document.querySelector('.site-header__search-container');
    if (!searchContainer) return;

    searchIsOpen = true;
    searchContainer.classList.add('is-active');
    document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
    
    // フォーカスを設定
    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  }

  function closeSearch() {
    const searchContainer = document.querySelector('.site-header__search-container');
    if (!searchContainer) return;

    searchIsOpen = false;
    searchContainer.classList.remove('is-active');
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
    
    // 予測検索の結果をクリア
    const predictiveResults = document.querySelector('#predictive-search');
    if (predictiveResults) {
      predictiveResults.style.display = 'none';
      predictiveResults.innerHTML = '';
    }

    // predictive-search要素からis-activeクラスを削除
    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch) {
      predictiveSearch.classList.remove('is-active');
    }
  }

  // DOMが読み込まれたら初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopifyテーマのページ遷移にも対応
  document.addEventListener('page:loaded', init);

})();